import SEOHead from "@/components/SEOHead";
import HiddenFeesChecker from "@/components/HiddenFeesChecker";
import TrustBar from "@/components/TrustBar";
import RelatedTools from "@/components/RelatedTools";
import SolutionsCrossSell from "@/components/SolutionsCrossSell";

export default function HiddenFeesCheckerPage() {
  return (
    <div>
      <SEOHead title="PCI & Hidden Fees Checker" description="Are you paying hidden or inflated fees on your card processing? Check your PCI, terminal rental, auth fees and more in 60 seconds." path="/hidden-fees-checker" />

      <section className="py-10 md:py-16 bg-gray-50" id="checker" data-testid="calculator-section">
        <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-6">
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-brand-aqua mb-2">Fee Health Check</p>
            <h1 className="font-heading text-3xl sm:text-4xl font-bold text-brand-black tracking-tight mb-3">Are you paying hidden fees?</h1>
            <p className="text-brand-grey leading-relaxed max-w-xl mx-auto">Enter the fees from your statement and we&apos;ll flag anything that looks high. Takes 60 seconds.</p>
          </div>
          <HiddenFeesChecker />
        </div>
      </section>

      <TrustBar />

      <RelatedTools currentPath="/hidden-fees-checker" />
      <SolutionsCrossSell currentPath="/hidden-fees-checker" />
    </div>
  );
}
